module.exports = __webpack_public_path__ + "img/avatar_yan.1b0ba9b3.png";